import React from "react";
import Divider from "@material-ui/core/Divider";
import { BrowserView, MobileView } from "react-device-detect";

//images
const img1 = "https://mspublicaccess.blob.core.windows.net/faqimages/aet1.png";

export default function EditTreatments() {
  return (
    <>
    <BrowserView>
    <div className="spacebottom">
      <h1 className="browserTitle">Add/Edit Treatments</h1>
      <ol className="listTop">
        <li>On the navigation menu on the left-hand side of the page, click on the “Admin Panel” dropdown and select “Treatments and Service</li>

        <img src={img1} alt="not found" width="80%" height="80%" />

        <br />
        <Divider />

        <li>You can edit Existing treatments by clicking on the highlighted edit button shown above.</li>
       
        <li>Or you can add a new template by clicking the green “Add Treatment” button on the top right. </li>
        <li>You can also view or delete the treatments using the corresponding buttons too. </li>

       
      </ol>
    </div>
    </BrowserView>
    <MobileView>
    <h1 className="mobileTitle">Add/Edit Treatments</h1>
      <ol className="listTop">
        <li>On the navigation menu on the left-hand side of the page, click on the “Admin Panel” dropdown and select “Treatments and Service</li>

        <img src={img1} alt="not found" width="80%" height="80%" />

        <br />
        <Divider />

        <li>You can edit Existing treatments by clicking on the highlighted edit button shown above.</li>
       
        <li>Or you can add a new template by clicking the green “Add Treatment” button on the top right. </li>
        <li>You can also view or delete the treatments using the corresponding buttons too. </li>

       
      </ol>
    </MobileView>
    </>

  );
}